import React from "react";
import { AccordionItem } from "../../Elements/Accordion";

export const AccordionInfo = ({ warnings }: { warnings: string[] }): JSX.Element => {
    return (
        <AccordionItem
            title="warnings item"
            defaultExpanded={Date.now()}
            changeHeight={Date.now()}
            nonExpandable={true}
            class="warnings-item"
        >
            {warnings.map((warning) => {
                return (
                    <div key={warning} className="accordion-info-item">
                        {warning}
                    </div>
                );
            })}
        </AccordionItem>
    );
};
